import React from 'react';
import { connect } from 'react-redux';
import Row from '../tag/Row';
import { find } from 'lodash';
import { FormattedMessage } from 'react-intl';
import OTButtonGroup from '../tag/OTButtonGroup';
import OTButton from '../tag/OTButton';
import { BIOBANK } from '../../data/reducer';
import { getTime } from '../../utils/TimeUtils';
import { hasConsent, hasActiveStatus } from '../../utils/BioBankUtil';
import BioBankHeader from './BioBankHeader';
import { withRouter } from 'react-router-dom';
import { doGetDocumentContent } from '../../data/biobank/actions';
import { compose } from 'redux';
import Loader from '../Loader';

const { id: module_id } = module;

class BioBankAgreement extends React.Component {
  back = () => {
    let { history } = this.props;
    history.push('/biobank/');
  };

  componentDidMount() {
    let {
      consentData,
      doGetDocumentContent,
      match: {
        params: { version },
      },
    } = this.props;

    if (
      consentData.data &&
      consentData.data.status === 'REFUSAL' &&
      version === 'current'
    )
      throw 'Invalid path';

    let context = version === 'current' ? 'currentConsent' : 'latestConsent';
    let documentVersion = version === 'current' ? consentData.version : null;

    doGetDocumentContent(context, 'CONSENT', documentVersion);
  }

  next = () => {
    let { match, history } = this.props;
    history.push(`/biobank/consent/${match.params.version}/2`);
  };

  isLoading = () => {
    let {
      documentContent: { status },
    } = this.props;
    return status == null || status === 'LOADING';
  };

  getContext = () => {
    let {
      match,
      consentData,
      documentContent: { data },
    } = this.props;
    switch (match.params.version) {
      case 'current':
        return {
          path: 'current',
          context: 'currentConsent',
          version: consentData.version,
        };
      case 'latest':
        return {
          path: 'latest',
          context: 'latestConsent',
          version: data.documentVersion,
        };
      default:
        return null;
    }
  };

  renderAttachment = () => {
    let {
      documentContent: { data },
    } = this.props;
    let { attachments } = data;
    let { text } = attachments[0];
    return (
      <div
        className="biobank-attachment"
        dangerouslySetInnerHTML={{ __html: text }}
      />
    );
  };

  render() {
    let { consentData, agreement, setAgreement } = this.props;

    if (this.isLoading()) return <Loader />;

    let version = this.getContext().version;

    return (
      <div className="biobank">
        <div className="biobank_agreement_content_title">
          <BioBankHeader>1/2</BioBankHeader>
        </div>
        <div className="biobank_agreement_content_container biobank_agreement_content_container_part0">
          {hasConsent(consentData) ? (
            <div
              className="biobank_green"
              style={{ textAlign: 'right', width: '100%' }}
            >
              <strong>
                <FormattedMessage
                  id={`${module_id}.agreement.consent.done.title`}
                  values={{
                    created: getTime(consentData.validFrom).format(
                      'DD.MM.YYYY'
                    ),
                  }}
                />
              </strong>
            </div>
          ) : (
            <></>
          )}
          <div
            className="biobank_version"
            style={{ textAlign: 'right', paddingBottom: '20px' }}
          >
            <FormattedMessage
              id={`${module_id}.agreement.consent.version`}
              values={{ version }}
            />
          </div>
          {/*  <div>
            <span className={"bold-text"}>
              <FormattedMessage id={`biobank.agreement.part1.title`}/>
            </span>
          </div>*/}
          <div>
            {this.renderAttachment()}
          </div>
          <div className="biobank_radio">
            <input
              className="biobank_radio-input"
              type="radio"
              name="agree"
              value="agree"
              id="agree"
              checked={agreement === true}
              onChange={() => {
                setAgreement(true);
              }}
            />
            <span className="biobank_radio-label">
              <FormattedMessage id={`${module_id}.agreement.understood`} />
            </span>
          </div>
          <Row>
            <OTButtonGroup type={'big'} expectedCount={2} collapseOnMobile>
              <OTButton
                className="ot-button--gray"
                key="submit"
                onClick={this.back}
              >
                <FormattedMessage id={`back`} />
              </OTButton>
              {hasActiveStatus(consentData) ? (
                <OTButton
                  className="ot-button--light"
                  key="readmore"
                  onClick={this.next}
                  disabled={!agreement}
                >
                  <FormattedMessage id={`next.page`} />
                </OTButton>
              ) : (
                <OTButton
                  className="ot-button--light"
                  key="readmore"
                  onClick={this.next}
                  disabled={!agreement}
                  style={{ marginLeft: '10px' }}
                >
                  <FormattedMessage id={`continue`} />
                </OTButton>
              )}
            </OTButtonGroup>
          </Row>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    consentData: state[BIOBANK].consentData.data,
    documentContent:
      ownProps.match.params.version === 'current'
        ? state[BIOBANK].consentDocumentContent
        : state[BIOBANK].latestConsentDocumentContent,
  };
};
/*

export default withRouter(connect(mapStateToProps, { doGetDocumentContent })(BioBankAgreement));
*/

export default compose(
  withRouter,
  connect(mapStateToProps, { doGetDocumentContent })
)(BioBankAgreement);
